import { useMemo, useCallback } from "react";
import { getCurrentDate } from "../../utils/dateUtils";
import { formatPhoneNumber } from "../../utils/numberFormatterUtil";
import { fieldNames } from "../../Components/CreateJob/CreateJobView/BuildQuote/constant";
export const useQuoteFormContent = ({
  signatureState,
  getValues,
  setValue,
}) => {
  const signatureDisplay = useMemo(() => {
    const displayUrl =
      signatureState?.url || getValues(fieldNames.SIGN_IMAGE_SRC);
    const displayText =
      signatureState?.textValue || getValues(fieldNames.SIGN_TEXT);

    return { url: displayUrl, text: displayText };
  }, [
    signatureState,
    getValues(fieldNames.SIGN_IMAGE_SRC),
    getValues(fieldNames.SIGN_TEXT),
  ]);

  const currentDate = useMemo(() => getCurrentDate(), []);

  const handlePhoneChange = useCallback(
    (e) => {
      const formattedNumber = formatPhoneNumber(e);
      setValue(fieldNames.QUOTE_PHONE, formattedNumber);
    },
    [setValue]
  );

  return {
    signatureDisplay,
    currentDate,
    handlePhoneChange,
  };
};
